import { TextInput, Typography } from "components/atoms";
import { ValidateErrorIcon } from "components/atoms/Icon";
import { useEffect, useState } from "react";

interface IProps {
  format: string;
  value: any;
  scoreViewModel?: any;
  goalViewModel: any;
  onChangeTestScore?: (e: any) => void;
  onChangeGoalScore: (e: any) => void;
}

export const TableInput = ({
  format,
  scoreViewModel,
  goalViewModel,
  value,
  onChangeTestScore,
  onChangeGoalScore,
}: IProps) => {
  const [scoreViewInputs, setScoreViewInputs] = useState(
    scoreViewModel?.Value.map((val: any) => ({
      Name: `${val.Name}`,
      Value: val.Value,
    }))
  );

  const [goalViewInputs, setgoalViewInputs] = useState(
    goalViewModel?.Value.map((val: any) => ({
      Name: `${val.Name}`,
      Value: val.Value,
    }))
  );

  const hasAllScoreViewInputsProvided =
    scoreViewInputs &&
    scoreViewInputs
      ?.filter((val: any) => val.Name !== "Composite Score")
      ?.every((value: any) => value.hasOwnProperty("Err"));

  const hasAllGoalViewInputsProvided =
    goalViewInputs &&
    goalViewInputs
      ?.filter((val: any) => val.Name !== "Composite Score")
      ?.every((value: any) => value.hasOwnProperty("Err"));

  const handleScoreViewChange = (
    input: any,
    fieldName: string,
    min: number,
    max: number
  ) => {
    let updatedScoreViewInputs = scoreViewInputs.map((obj: any) =>
      obj.Name === fieldName
        ? {
            Name: fieldName,
            Value: parseInt(input),
            Err:
              Number.isNaN(parseInt(input)) ||
              parseInt(input) > max ||
              parseInt(input) < min
                ? `Please enter a number between ${min} and ${max}`
                : "",
          }
        : obj
    );
    const compositeScoreValue = updatedScoreViewInputs
      .filter((val: any) => val.Name !== "Composite Score")
      .map((val: any) => (Number.isNaN(parseInt(val.Value)) ? 0 : val.Value))
      .reduce((acc: number, curr: number) => acc + curr, 0);

    updatedScoreViewInputs = updatedScoreViewInputs.map((obj: any) =>
      obj.Name === "Composite Score"
        ? { ...obj, Value: compositeScoreValue }
        : obj
    );
    setScoreViewInputs(updatedScoreViewInputs);
  };

  const handleGoalViewChange = (
    input: any,
    fieldName: string,
    min: number,
    max: number
  ) => {
    let updatedGoalViewInputs = goalViewInputs.map((obj: any) =>
      obj.Name === fieldName
        ? {
            Name: fieldName,
            Value: parseInt(input),
            Err:
              Number.isNaN(parseInt(input)) ||
              parseInt(input) > max ||
              parseInt(input) < min
                ? `Please enter a number between ${min} and ${max}`
                : "",
          }
        : obj
    );
    const compositeScoreValue = updatedGoalViewInputs
      .filter((val: any) => val.Name !== "Composite Score")
      .map((val: any) => (Number.isNaN(parseInt(val.Value)) ? 0 : val.Value))
      .reduce((acc: number, curr: number) => acc + curr, 0);

    updatedGoalViewInputs = updatedGoalViewInputs.map((obj: any) =>
      obj.Name === "Composite Score"
        ? { ...obj, Value: compositeScoreValue }
        : obj
    );
    setgoalViewInputs(updatedGoalViewInputs);
  };

  useEffect(() => {
    onChangeTestScore && onChangeTestScore(scoreViewInputs);
  }, [scoreViewInputs]);

  useEffect(() => {
    onChangeGoalScore(goalViewInputs);
  }, [goalViewInputs]);

  return format === "multiple" ? (
    <>
      <table className="score-table">
        <thead className="custom-table-css">
          <tr>
            <td></td>
            <td>Your score</td>
            <td>Goal score</td>
          </tr>
        </thead>
        <tbody className="custom-table-css">
          {scoreViewModel?.Value.map((value: any, index: number) =>
            value.ScoreType !== "CompositeScoreSum" ? (
              <tr key={index}>
                <td>{value.Name}</td>
                <td>
                  <TextInput
                    placeholder={`${value.ScaleMinValue} - ${value.ScaleMaxValue}`}
                    type="number"
                    style={`score-table-input-field ${hasAllScoreViewInputsProvided && (Number.isNaN(parseInt(scoreViewInputs[index].Value)) || scoreViewInputs[index].Value < value.ScaleMinValue || scoreViewInputs[index].Value > value.ScaleMaxValue) ? "invalid" : ""}`}
                    onChange={(e: any) =>
                      handleScoreViewChange(
                        e.target.value,
                        value.Name,
                        value.ScaleMinValue,
                        value.ScaleMaxValue
                      )
                    }
                  />
                </td>
                <td>
                  <TextInput
                    placeholder={`${goalViewModel?.Value[index].ScaleMinValue} - ${goalViewModel?.Value[index].ScaleMaxValue}`}
                    type="number"
                    style={`score-table-input-field ${hasAllGoalViewInputsProvided && (Number.isNaN(parseInt(goalViewInputs[index].Value)) || goalViewInputs[index].Value < value.ScaleMinValue || goalViewInputs[index].Value > value.ScaleMaxValue) ? "invalid" : ""}`}
                    onChange={(e: any) =>
                      handleGoalViewChange(
                        e.target.value,
                        value.Name,
                        value.ScaleMinValue,
                        value.ScaleMaxValue
                      )
                    }
                  />
                </td>
              </tr>
            ) : null
          )}
          {scoreViewModel?.Value.filter(
            (val: any) => val.ScoreType === "CompositeScoreSum"
          ).map((value: any, index: number) => (
            <tr key={index}>
              <td>{value.Name}</td>
              <td>
                <TextInput
                  disabled={true}
                  style="score-table-input-field"
                  value={scoreViewInputs[0].Value}
                />
              </td>
              <td>
                <TextInput
                  disabled={true}
                  style="score-table-input-field"
                  value={goalViewInputs[0].Value}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="input-errors-wrapper">
        {hasAllScoreViewInputsProvided &&
          scoreViewInputs
            .filter((val: any) => val.Name !== "Composite Score")
            .map((val: any, index: number, arr: any) =>
              val.hasOwnProperty("Err") &&
              val.Err !== "" &&
              arr[arr.length - 1]?.hasOwnProperty("Err") ? (
                <div className="icon-with-error-wrapper" key={index}>
                  <ValidateErrorIcon />
                  <Typography
                    label={val.Err}
                    variant="h6Book"
                    styles="error-msg-custom-style"
                  />
                </div>
              ) : null
            )}
        {hasAllGoalViewInputsProvided &&
          goalViewInputs
            .filter((val: any) => val.Name !== "Composite Score")
            .map((val: any, index: number, arr: any) =>
              val.hasOwnProperty("Err") &&
              val.Err !== "" &&
              arr[arr.length - 1]?.hasOwnProperty("Err") ? (
                <div className="icon-with-error-wrapper" key={index}>
                  <ValidateErrorIcon />
                  <Typography
                    label={val.Err}
                    variant="h6Book"
                    styles="error-msg-custom-style"
                  />
                </div>
              ) : null
            )}
      </div>
    </>
  ) : (
    <>
      <table className="score-table">
        <tbody className="custom-table-css">
          {goalViewModel?.Value.map((value: any, index: number) =>
            value.ScoreType !== "CompositeScoreSum" ? (
              <tr key={index}>
                <td>{value.Name}</td>
                <td>
                  <TextInput
                    placeholder={`${value.ScaleMinValue} - ${value.ScaleMaxValue}`}
                    type="number"
                    style={`score-table-input-field ${hasAllGoalViewInputsProvided && (goalViewInputs[index].Value < value.ScaleMinValue || goalViewInputs[index].Value > value.ScaleMaxValue) ? "invalid" : ""}`}
                    onChange={(e: any) =>
                      handleGoalViewChange(
                        e.target.value,
                        value.Name,
                        value.ScaleMinValue,
                        value.ScaleMaxValue
                      )
                    }
                  />
                </td>
              </tr>
            ) : null
          )}
          {goalViewModel?.Value.filter(
            (val: any) => val.ScoreType === "CompositeScoreSum"
          ).map((value: any, index: number) => (
            <tr key={index}>
              <td>{value.Name}</td>
              <td>
                <TextInput
                  disabled={true}
                  style="score-table-input-field"
                  value={goalViewInputs[0].Value}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="input-errors-wrapper">
        {hasAllGoalViewInputsProvided &&
          goalViewInputs
            .filter((val: any) => val.Name !== "Composite Score")
            .map((val: any, index: number, arr: any) =>
              val.hasOwnProperty("Err") &&
              val.Err !== "" &&
              arr[arr.length - 1]?.hasOwnProperty("Err") ? (
                <div className="icon-with-error-wrapper" key={index}>
                  <ValidateErrorIcon />
                  <Typography
                    label={val.Err}
                    variant="h6Book"
                    styles="error-msg-custom-style"
                  />
                </div>
              ) : null
            )}
      </div>
    </>
  );
};
